(function () {
  var root = document.querySelector('[data-urgency-exit]');
  if (!root) return;

  var debug = /[?&]exitdebug=1/.test(window.location.search);
  var key = root.dataset.storageKey;
  var delay = debug ? 0 : (parseInt(root.dataset.delay, 10) || 0);
  var mobileFallback = root.dataset.mobileFallback === 'true';
  var panel = root.querySelector('.urgency-exit__panel');

  var TOLERANCE = 10;

  var armed = false;
  var shown = false;
  var pointerSeen = false;
  var lastFocused = null;

  function seen() {
    if (debug) return false;
    try {
      return localStorage.getItem(key) === '1';
    } catch (e) {
      return true;
    }
  }

  function remember() {
    if (debug) return;
    try {
      localStorage.setItem(key, '1');
    } catch (e) {}
  }

  if (seen()) {
    if (debug) console.log('[exit] already seen — stopping');
    return;
  }

  function focusables() {
    return panel.querySelectorAll('a[href], button:not([disabled])');
  }

  function trap(event) {
    if (event.key === 'Escape') return close();
    if (event.key !== 'Tab') return;

    var items = focusables();
    if (!items.length) return;

    var first = items[0];
    var last = items[items.length - 1];

    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  function open(reason) {
    if (shown) return;
    shown = true;
    remember();
    teardown();

    if (debug) console.log('[exit] opening — trigger:', reason);

    lastFocused = document.activeElement;
    root.removeAttribute('hidden');
    document.body.classList.add('urgency-exit-open');

    requestAnimationFrame(function () {
      root.classList.add('is-visible');
      var target = panel.querySelector('.urgency-exit__close');
      if (target) target.focus();
    });

    document.addEventListener('keydown', trap);
  }

  function close() {
    root.classList.remove('is-visible');
    document.body.classList.remove('urgency-exit-open');
    document.removeEventListener('keydown', trap);

    setTimeout(function () {
      root.setAttribute('hidden', '');
      if (lastFocused && lastFocused.focus) lastFocused.focus();
    }, 200);
  }

  function onPointerMove() {
    pointerSeen = true;
  }

  function onLeave(event) {
    if (!armed || shown || !pointerSeen) return;
    if (event.clientY > TOLERANCE) return;
    open('mouseleave');
  }

  function onBlur() {
    if (!armed || shown || !pointerSeen) return;
    open('window blur');
  }

  function teardown() {
    document.documentElement.removeEventListener('mouseleave', onLeave);
    document.removeEventListener('mousemove', onPointerMove);
    window.removeEventListener('blur', onBlur);
  }

  root.querySelectorAll('[data-urgency-exit-close]').forEach(function (el) {
    el.addEventListener('click', close);
  });

  document.addEventListener('mousemove', onPointerMove, { once: true });

  setTimeout(function () {
    armed = true;

    if (debug) console.log('[exit] armed');

    if (window.matchMedia('(hover: none)').matches) {
      if (mobileFallback) setTimeout(function () { open('mobile timer'); }, 45000);
      return;
    }

    document.documentElement.addEventListener('mouseleave', onLeave);
    window.addEventListener('blur', onBlur);
  }, delay);
})();